<!-- <div class="flex flex-row items-center">
  <div class="flex flex-row items-center justify-center">
    <mat-icon *ngIf="data.messages" class="icon-size-14" svgIcon="confirm_{{ data.type }}"></mat-icon>
    <mat-icon *ngIf="!data.messages" class="icon-size-12" svgIcon="confirm_{{ data.type }}"></mat-icon>
  </div>
  <div class="flex flex-col">
    <span class="text-h5 text-theme-dark font-bold">{{ data.title }}</span>
    <span class="text-b1 text-theme-gray whitespace-pre-line">{{ data.messages }}</span>
  </div>
</div> -->

<div class="flex items-center gap-3">
  <!-- <mat-icon class="icon-size-6 text-white">done</mat-icon> -->
  <div class="flex-grow min-w-0">
    <div class="text-s2-16 font-bold whitespace-pre-line break-words">{{ data.title }}</div>
    <div class="text-b2-14 whitespace-pre-line break-words">{{ data.messages }}</div>
  </div>
  <mat-icon (click)="snackBarRef.dismiss()" class="icon-size-6 text-white cursor-pointer">close</mat-icon>
</div>
